import { BookOption, SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createBookValidationSchema = Yup.object().shape({
  name: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  genreName: Yup.string().when("isGenerateThumbnailsByAI", {
    is: true,
    then: (schema) => schema.required(SystemMessage.INPUT_REQUIRED),
    otherwise: (schema) => schema,
  }),
  categoryIds: Yup.array().min(1, SystemMessage.INPUT_REQUIRED),

  bookOption: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  mediaType: Yup.string().required(SystemMessage.INPUT_REQUIRED),

  price: Yup.number()

    .transform((value, originalValue) =>

      String(originalValue).trim() === "" ? null : value

    )

    .nullable()

    .integer()

    .typeError(SystemMessage.INPUT_INVALID_PRICE)

    .when("bookOption", {

      is: (val: string) => val === BookOption.PURCHASE.toString(),

      then: (schema) =>

        schema

          .required(SystemMessage.INPUT_REQUIRED)

          .min(1, SystemMessage.INPUT_INVALID_PRICE),

      otherwise: (schema) => schema,

    }),

  ebookPrice: Yup.number()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value
    )
    .nullable()
    .integer()
    .typeError(SystemMessage.INPUT_INVALID_PRICE)
    .when("mediaType", {
      is: (val: string) => val === "2" || val === "3",
      then: (schema) =>
        schema
          .required(SystemMessage.INPUT_REQUIRED)
          .min(0, SystemMessage.INPUT_INVALID_PRICE),
      otherwise: (schema) => schema,
    }),

  oldPrice: Yup.number()

    .transform((value, originalValue) =>

      String(originalValue).trim() === "" ? null : value

    )

    .nullable()

    .integer()

    .typeError(SystemMessage.INPUT_INVALID_PRICE),

  // authorId: Yup.number().min(1, SystemMessage.INPUT_REQUIRED),

  // musicId: Yup.number().min(1, SystemMessage.INPUT_REQUIRED),

  description: Yup.string().required(SystemMessage.INPUT_REQUIRED),

  elements: Yup.array().of(

    Yup.object().shape({

      name: Yup.string().required(SystemMessage.INPUT_REQUIRED),

      description: Yup.string(),

      point: Yup.number()

        .required(SystemMessage.INPUT_REQUIRED)

        .integer()
        .typeError(SystemMessage.INPUT_INVALID_POINT),
      children: Yup.array().of(
        Yup.object().shape({
          point: Yup.number()
            .required(SystemMessage.INPUT_REQUIRED)
            .integer()
            .typeError(SystemMessage.INPUT_INVALID_POINT),
        })
      ),
    })
  ),
  isGenerateThumbnailsByAI: Yup.boolean(),
});
